import { QuestionStep } from '../QuestionStep';
import { MultiChip } from './_shared';
import {
  AUDIENCE_OPTIONS,
  AGE_GROUP_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface AudienceStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function AudienceStep({ answers, onChange }: AudienceStepProps) {
  const step = STEPS.find((s) => s.id === 'audience')!;

  return (
    <QuestionStep step={step}>
      <div className="grid gap-8">
        <div>
          <p className="smallcaps mb-3 text-graphite">Audiences</p>
          <MultiChip
            options={AUDIENCE_OPTIONS}
            values={answers.audience ?? []}
            onChange={(v) => onChange({ audience: v })}
          />
        </div>

        <div>
          <p className="smallcaps mb-3 text-graphite">Age groups</p>
          <MultiChip
            options={AGE_GROUP_OPTIONS}
            values={answers.age_groups ?? []}
            onChange={(v) => onChange({ age_groups: v })}
          />
          <p className="mt-3 font-mono text-[11px] text-graphite leading-relaxed">
            <span className="text-ochre">¶</span>&nbsp;&nbsp;If you pick "Children", AURA enforces stricter accessibility and tone constraints downstream.
          </p>
        </div>
      </div>
    </QuestionStep>
  );
}
